import axios, { type AxiosResponse } from '@fs/zion-axios'
import { ROOTSTECH_SERVICE as SERVICE } from '../../serviceNames'
import { eventConfig } from '../../../config'
import { getLocaleConfig } from '../../helpers/requestConfig'

// DOCS: https://icseng.atlassian.net/wiki/x/GR73Bw

type TimeSlot = { date: string; time: string }
type ScheduleBody = Record<string, unknown>

const BASE = `${SERVICE}/schedules/${eventConfig.conference}`

// Get User Schedule for Event
export const getUserSchedule = async (): Promise<AxiosResponse> => {
  return axios.get(`${BASE}`, getLocaleConfig())
}

/**
 * Get Daily Schedule for Event
 * @param date The day of the event, pattern: \d{4}-\d{2}-\d{2}, example: 2023-01-31
 */
export const getDaySchedule = async ({ date }: Pick<TimeSlot, 'date'>): Promise<AxiosResponse> => {
  return axios.get(`${BASE}/${date}`, getLocaleConfig())
}

/**
 * Put Preferences for Time Slot
 * @param date The day of the event, pattern: \d{4}-\d{2}-\d{2}, example: 2023-01-31
 * @param time The time slot to be updated, pattern: \d{2}:\d{2}, example: 14:00
 * @param body The user's preferences for the given time slot
 */
export const updateTimeSlot = async ({ date, time }: TimeSlot, body: ScheduleBody): Promise<AxiosResponse> => {
  return axios.put(`${BASE}/${date}/${time}`, body, getLocaleConfig())
}

/**
 * Update User Schedule for Event.
 * This service is only used to consolidate the Calendar data with
 * the classes that were added to mySchedule
 * @param body The user's schedule
 */
export const updateSchedule = async (body: ScheduleBody): Promise<AxiosResponse> => {
  return axios.put(`${BASE}`, body, getLocaleConfig())
}

/**
 * Delete Preferences for Time Slot
 * @param date The day of the event, pattern: \d{4}-\d{2}-\d{2}, example: 2023-01-31
 * @param time The time slot to be updated, pattern: \d{2}:\d{2}, example: 14:00
 */
export const deleteTimeSlot = async ({ date, time }: TimeSlot): Promise<AxiosResponse> => {
  return axios.delete(`${BASE}/${date}/${time}`, getLocaleConfig())
}

// Get the list of locales from mySchedule
export const getScheduleLocales = async (): Promise<AxiosResponse> => {
  return axios.get(`${BASE}/locales`, getLocaleConfig())
}
